<template>
  <div class="col-span-full border-t border-white opacity-40" />
</template>
